import React, { useEffect, useState } from "react";
import axios from "axios";

const NotificationPopup = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [notifications, setNotifications] = useState([]);
  const [show, setShow] = useState(false);

  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        const response = await axios.get(
          "https://apis.chemistforall.com/v1/auth/user/recent-orders"
        );
        setNotifications(response.data?.data || []);
      } catch (error) {
        console.error("Failed to fetch recent orders:", error);
      }
    };

    fetchNotifications();
  }, []);

  useEffect(() => {
    if (notifications.length === 0) return;

    const interval = setInterval(() => {
      setShow(true);
      setTimeout(() => setShow(false), 10000);
      setCurrentIndex((prev) => (prev + 1) % notifications.length);
    }, 50000);

    return () => clearInterval(interval);
  }, [notifications]);

  const handleClose = () => setShow(false); 

  if (!show || notifications.length === 0) return null;

  const { location, product, image } = notifications[currentIndex] || {};

  return (
    <div style={styles.container}>
      <button style={styles.closeBtn} onClick={handleClose}>
        ×
      </button>
      <img src={image} alt="product" style={styles.image} />
      <div>
        <p style={styles.text}>
          <strong>Someone in {location}</strong>
        </p>
        <p style={styles.text}>
          recently purchased <span style={styles.link}>{product}</span>
        </p>
      </div>
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  container: {
    position: "fixed",
    bottom: 20,
    left: 20,
    width: window.innerWidth <= 480 ? 250 : 340, // smaller width on mobile
    backgroundColor: "#fff",
    boxShadow: "0 0 15px rgba(0,0,0,0.1)",
    borderRadius: 6,
    padding: window.innerWidth <= 480 ? 6 : 10, // less padding on mobile
    display: "flex",
    gap: window.innerWidth <= 480 ? 6 : 10,
    zIndex: 1000,
    animation: "fadeIn 0.5s ease-in-out",
    alignItems: "center",
  },
  image: {
    width: window.innerWidth <= 480 ? 38 : 60, // smaller image on mobile
    height: window.innerWidth <= 480 ? 38 : 60,
    objectFit: "contain",
    borderRadius: 4,
  },
  text: {
    margin: 0,
    fontSize: window.innerWidth <= 480 ? 12 : 14, // smaller font on mobile
    color: "#333",
  },
  link: {
    color: "#669900",
    fontWeight: "bold",
  },
  closeBtn: {
    position: "absolute",
    top: 4,
    right: 8,
    background: "transparent",
    border: "none",
    fontSize: window.innerWidth <= 480 ? 16 : 18, // smaller close button
    cursor: "pointer",
    lineHeight: "1",
  },
};

export default NotificationPopup;
